"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (fn, context) {
  return function () {
    return fn.apply(context, arguments);
  };
};

; /**
   * 利用apply 为函数绑定指定的上下文对象
   */

/**
 * @param {Function} fn 需要绑定的函数
 * @param {Object} context 函数执行的环境、上下文对象
 */


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/applyBind.js
// module id = 90
// module chunks = 0